const environment = {
    hostUrl: 'https://api.bridgement.com'
};

export default environment;
